export const HANDLE_USER_PROFILE_PICTURE_SELECTION = 'HANDLE_USER_PROFILE_PICTURE_SELECTION';

export const selectProfilePicture = (profilePicture = '') => {
    return ({
        type: HANDLE_USER_PROFILE_PICTURE_SELECTION,
        payload: { profilePicture }
    });
};
